import React, { useEffect, useState } from 'react';
import PlumbingIcon from '@mui/icons-material/Plumbing';

import API from '../../../sharedModules/utils/axios.utils';
import ListPage from '../../../sharedModules/listPage/ListPage';

const columns = [
  { name: 'Order', selector: 'order_no', sortable: true },
  { name: 'Scheduled', selector: 'schedule_dates', sortable: true },
  { name: 'Company', selector: 'company_name', sortable: true },
  { name: 'Logging Tech', selector: 'display_emp_id', sortable: true },
  { name: 'System No', selector: 'system_no', sortable: true },
  { name: 'Flags', selector: 'flags', sortable: true },
];

const defaultFilters = { has_flags: 'true' };

const FlaggedDevicesListPage: React.FC = () => {
  const [loggingTechOptions, setLoggingTechOptions] = useState<{ label: string; value: string }[]>([]);

  const fetchLoggingTechOptions = async () => {
    try {
      const response: any = await API.get('/backflows/backflow_job_items/options', {
        params: {
          value: 'emp_id',
          label: 'display_emp_id',
          'ransack[has_flags]': 'true',
        },
      });
      setLoggingTechOptions(response.data.result ?? []);
    } catch (error) {
      console.error('Error fetching logging tech options:', error);
    }
  };

  useEffect(() => {
    fetchLoggingTechOptions();
  }, []);

  const filterDefinitions = [
    {
      label: 'Flag Reason',
      type: 'select',
      param: 'flag_reason_eq',
      choices: [
        { label: 'New Device', value: 'New Device' },
        { label: 'Out of Service', value: 'Out of Service' },
        { label: 'Failed Test', value: 'Failed Test' },
      ],
    },
    {
      label: 'Logging Tech',
      type: 'select',
      param: 'emp_id_eq',
      choices: loggingTechOptions,
    },
  ];

  return (
    <ListPage
      clickableRows
      columns={columns}
      controller="backflows/backflow_job_items"
      defaultFilters={defaultFilters}
      clearedFilterSetting={defaultFilters}
      defaultSort="created_at desc"
      filterDefinitions={filterDefinitions}
      includeFilterBar
      includeQuerySearch={false}
      // queryPlaceholder="Search by Company or System No"
      rowClickPath="backflow_tests/backflow_form"
      // rowClickQueryString="backLink=/backflow_tests/flagged_devices"
      title="Flagged Devices"
      titleIcon={<PlumbingIcon />}
    />
  );
};

export default FlaggedDevicesListPage;
